import React from 'react';
import PropTypes from 'prop-types';

import styles from '../sideMenu/SideMenu.m.sass';
import SideMenu from '../sideMenu/SideMenu';
import MenuContainer from '../../containers/menuContainer/MenuContainer';

export default function HeaderSideMenu({isOpen, onStateChange, searchValue, cartItemCount}) {
  const closeMenu = () => onStateChange(false);

  return (
    <SideMenu isOpen={isOpen} onStateChange={onStateChange} searchValue={searchValue} cartItemCount={cartItemCount}>
      <div className={styles.sideMenu_nav}>
        <MenuContainer mobile/>
      </div>
    </SideMenu>
  );
}



// WEBPACK FOOTER //
// ./components/header/HeaderSideMenu.js